import { render, staticRenderFns } from "./MainBookCompCard.vue?vue&type=template&id=a8091d38"
import script from "./MainBookCompCard.vue?vue&type=script&lang=js"
export * from "./MainBookCompCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports